module.exports = __webpack_public_path__ + "static/media/cartouche-title.4805c5a3.jpg";